<template>
  <el-card>
    <el-form :inline="true" :model="searchFactor" class="search-form">
        <el-form-item label="唯一码:"  >
          <el-input v-model="searchFactor.uniqNo" style="width: 100px"></el-input>
        </el-form-item>
        <el-form-item label="模块:">
          <el-select style="width:150px" v-model="searchFactor.moduleId" placeholder="请选择" >
            <el-option
              label="全部"
              value="">
            </el-option>
            <el-option
              v-for="item in qmInfoList"
              :key="item.id"
              :label="item.moduleName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题型:">
          <el-select style="width:130px"  v-model="searchFactor.answerCheckType" placeholder="请选择">
            <el-option
              label="全部"
              value="">
            </el-option>
            <el-option
              v-for="(item,index) in answerCheckTypeList"
              :key="index"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态:" >
      <el-select style="width: 100px" v-model="searchFactor.active" placeholder="请选择" >
        <el-option
          v-for="item in actStateOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </el-form-item>
        <el-form-item label="问题:" >
          <el-input v-model="searchFactor.question"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleCreateQb">创建</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleActvieBat">批量激活</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleUnActiveBat">批量禁用 </el-button>
        </el-form-item>
        <el-upload
        style="display: inline-block"
        ref='upload'
        :action="qbInfoFile.url"
        :headers="qbInfoFile.headers"
        :multiple="false"
        :limit="qbInfoFile.limit"
        :name="qbInfoFile.file"
        :on-success="fileUpLoadSuccess"
        :show-file-list="true"
        :on-error="fileUpLoadError">
        <el-button type="primary" >导入</el-button>
      </el-upload>
    </el-form>
    <el-table
      :data="tableData"
      :stripe ="true"
      :border = "true"
      ref="multipleTable"
      :highlight-current-row ="false"
      height="calc(100vh - 200px)"
      @selection-change="handleSelectionChange"
      max-height="calc(100vh - 200px)"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%">
      <el-table-column
        type="selection"
        width="55">
      </el-table-column>
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="moduleName"
        label="知识模块"
        width="80" >
      </el-table-column>
      <el-table-column
        prop="basicState"
        label="实验室准入教程"
        min-width="70">
        <template slot-scope="scope">
          <span v-if = "scope.row.basicState == 1" style="color: greenyellow"> 是</span>
          <span v-else style="color: red" > 否</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="uniqNo"
        label="唯一码"
        width="60" >
      </el-table-column>
      <el-table-column
        prop="answerCheckType"
        label="题型"
        width="80" >
      </el-table-column>
      <el-table-column
        prop="question"
        label="问题"
        min-width="150">
      </el-table-column>
      <el-table-column
        prop="option"
        label="选项"
        min-width="250"  :formatter="formatContent">
      </el-table-column>
      <el-table-column min-width="120px" prop="picture" label="图片区">
        <template slot-scope="scope">
          <el-badge v-if = "scope.row.countImage  > 0 "
           style="margin-top: 20px;
            margin-right: 100px;" :value=" '+' +scope.row.countImage" >
            <img :src="scope.row.fileUrl1" fit="fit"  height="80"/>
          </el-badge>
        </template>
      </el-table-column>

      <el-table-column
        prop="answer"
        label="答案"
        min-width="60">
      </el-table-column>
      <el-table-column
        prop="analysis"
        label="解析"
       min-width="200">
      </el-table-column>
      <el-table-column
      prop="active"
      width="70"
      label="状态" >
      <template slot-scope="scope">
          <span v-if = "scope.row.active == 0" style="color: red"> 禁用</span>
          <span v-else style="color: greenyellow" > 激活</span>
      </template>
    </el-table-column>
      <el-table-column
        prop="createUser"
        label="创建者"
        min-width="100">
      </el-table-column>
      <!-- <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="100">
      </el-table-column> -->
      <!-- <el-table-column
        prop="updateUser"
        min-width="100"
        label="更新者">
      </el-table-column>
      <el-table-column
        prop="updateTime"
        min-width="100"
        label="更新时间">
      </el-table-column> -->
      <el-table-column label="操作" min-width="120px">
        <template slot-scope="scope" >
          <el-dropdown split-button type="primary" @command="handleCommand">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"doActiveQb",index:scope.$index, data:scope.row}'>
                <i :class="scope.row.active == 0 ? 'el-icon-star-on':'el-icon-star-off' "  :style="scope.row.active == 0 ?'color:rgb(40, 238, 10)' :'color:rgb(246, 102, 18)'" ></i> 
                <span>{{scope.row.active == 0?'激活':'禁用'}}</span>
              </el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleViewQb",index:scope.$index, data:scope.row}'> <i class="el-icon-search" style="color:rgb(39, 193, 231)" ></i> <span>预览</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleEditQb",index:scope.$index, data:scope.row}'><i class="el-icon-edit" style="color:rgb(41, 10, 239)" ></i> <span>编辑</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleDelete", index:scope.$index,data:scope.row}'><i class="el-icon-delete-solid" style="color:rgb(246, 102, 18)" ></i> <span>删除</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,prev, pager, next"
      @current-change="handleCurrentChange"
      :current-page.sync="pager.currentPage"
      :page-size="pager.pageSize"
      :total="pager.totalCount" style="margin: 10px">
    </el-pagination>
    
    <!-- 创建题目弹窗 -->
    <el-dialog :visible.sync="dialogVisual.initQbVisual" :close-on-click-modal="false" v-on:close ="clearInitQbForm" >
      <div slot="title" class="dialog-footer">
        <span> 创建一个知识题目 </span>
      </div>
      <el-form  label-position="right" label-width="20%" :model="qbWithfileUpload">
          <el-form-item style="width:80%" label="模块和类型:">
            <el-row :gutter="10">
              <el-col :span= 10>
              <el-select style="width:100%" @change = 'createQbWithQmChange' v-model="qbWithfileUpload.moduleId" placeholder="请选择" >
                <el-option
                  v-for="item in qmInfoList"
                  :key="item.id"
                  :label="item.moduleName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span= 7>
              <el-select style="width:100%"  v-model="qbWithfileUpload.answerCheckType" placeholder="题型">
                <el-option
                  v-for="(item,index) in answerCheckTypeList"
                  :key="index"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span= 2 >
              <el-checkbox v-model="qbWithfileUpload.basicState" disabled >实验室准入教程</el-checkbox>
            </el-col>
            </el-row>
          </el-form-item>
          <el-form-item style="width:80%" label="问题:">
            <el-input type="textarea" rows = 3 v-model="qbWithfileUpload.question" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item  v-for="(item,index) in qbWithfileUpload.optionArr" :key="index" style="width:80%;" :label=" '选项' + String.fromCharCode(index+1 + 64) + ':'">
            <el-col :span="18">
              <el-input v-model="qbWithfileUpload.optionValueArr[index]" ></el-input>
            </el-col>
            <el-col :span="6">
              <el-button type="success" icon="el-icon-plus"  circle size="mini"  @click="addOption(index)"> </el-button>
              <el-button  type="danger" icon="el-icon-delete" circle size="mini"  @click="delOption(index)"> </el-button>
            </el-col>
          </el-form-item>
          <el-form-item style="width:80%" label="答案:">
            <el-input  v-model="qbWithfileUpload.answer" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item style="width:80%"  label="分析:">
            <el-input type="textarea"  rows = 2 v-model="qbWithfileUpload.analysis" autocomplete="off"></el-input>
          </el-form-item>
      </el-form>
      <div>
        <el-upload
          :action="'#'"
          list-type="picture-card"
          :auto-upload="false"
          :ref="qbWithfileUpload.refElUpload"    
          :limit="qbWithfileUpload.limit">
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{file}">
            <el-badge :value="getIndex(file,qbWithfileUpload.refElUpload)" style="margin: 10px;">
             <img class="el-upload-list__item-thumbnail" :src="file.url" alt  />
            </el-badge>
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-delete"
                @click="handleRemove(file,qbWithfileUpload.refElUpload)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
    
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureCreate">创建</el-button>
      </div>
    </el-dialog>
    

    <!-- 修改弹窗 -->
    <el-dialog :visible.sync="dialogVisual.editQbVisual" v-on:close ="clearEditQbForm" >
      <div slot="title" class="dialog-footer">
        <span> 修改一个知识题目 </span>
      </div>
      <el-form  label-position="right" label-width="20%" :model="qbWithfileUploadEdit">
        <el-form-item style="width:80%" label="模块和类型:">
          <el-row  :gutter="10">
            <el-col :span= 10>
              <el-select style="width:100%" @change = 'updateQbWithQmChange' v-model="qbWithfileUploadEdit.moduleId" placeholder="请选择" >
                <el-option
                  v-for="item in qmInfoList"
                  :key="item.id"
                  :label="item.moduleName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span= 7>
              <el-select style="width:100%"  v-model="qbWithfileUploadEdit.answerCheckType" placeholder="题型">
                <el-option
                  v-for="(item,index) in answerCheckTypeList"
                  :key="index"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span= 2 >
              <el-checkbox v-model="qbWithfileUploadEdit.basicState" disabled >实验室准入教程</el-checkbox>
            </el-col>
         </el-row>
        </el-form-item>
        <el-form-item style="width:80%" label="问题:">
          <el-input type="textarea" rows = 3 v-model="qbWithfileUploadEdit.question" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item  v-for="(item,index) in qbWithfileUploadEdit.optionArr" :key="index" style="width:80%;" :label=" '选项' + String.fromCharCode(index+1 + 64) + ':'">
          <el-col :span="18">
            <el-input v-model="qbWithfileUploadEdit.optionValueArr[index]" ></el-input>
          </el-col>
          <el-col :span="6">
            <el-button type="success" icon="el-icon-plus"  circle size="mini"  @click="addOption(index)"> </el-button>
            <el-button  type="danger" icon="el-icon-delete" circle size="mini"  @click="delOption(index)"> </el-button>
          </el-col>
        </el-form-item>
        <el-form-item style="width:80%" label="答案:">
          <el-input  v-model="qbWithfileUploadEdit.answer" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item style="width:80%"  label="分析:">
          <el-input type="textarea"  rows = 2 v-model="qbWithfileUploadEdit.analysis" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="更新封面:" style="width:90%">
        <el-switch
          v-model="qbWithfileUploadEdit.updateImage"
          active-text="是"
          inactive-text="否"  @change ="funcUpdateImageChange">
        </el-switch>
      </el-form-item>
      <el-form-item label="更新图片:" style="width:90%">
        <el-upload
          :action="'#'"
          list-type="picture-card"
          :auto-upload="false"
          :ref="qbWithfileUploadEdit.refElUpload"    
          :file-list="qbWithfileUploadEdit.fileListShow"
          :limit="qbWithfileUploadEdit.limit">
          <i slot="default" class="el-icon-plus"></i>
          <div slot="file" slot-scope="{file}">
            <el-badge :value="getIndex(file,qbWithfileUploadEdit.refElUpload)" style="margin: 10px;">
             <img class="el-upload-list__item-thumbnail" :src="file.url" alt  />
            </el-badge>
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-delete"
                @click="handleRemove(file,qbWithfileUploadEdit.refElUpload)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
          </div>
        </el-upload>
      </el-form-item>
    </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="ensureEdit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 预览一个试题 -->
    <el-dialog :visible.sync="dialogVisual.viewQbVisual" v-on:close ="clearViewQbForm" >
      <el-card class="box-card">
        <div slot="header" class="clearfix" style="display:flex;justify-content:space-between">
          <div>
            <el-tag type="warning">{{ qbView.uniqNo }}</el-tag>
            <el-tag>{{ qbView.moduleName }}</el-tag>
            <el-tag type="success">{{  qbView.answerCheckType }}</el-tag>
          </div>
          <el-checkbox v-model="qbView.basicState" disabled >实验室准入教程</el-checkbox>
        </div>
        <div style ="margin-top: 10px;" >
          <el-tag type="warning">问题</el-tag>
          <span style ="margin-left: 10px;">{{qbView.question }}</span>
        </div>
        <div style ="margin-top: 10px;" v-if = "qbView.imageUrlList.length > 0"> 
          <el-tag type="warning" style="padding-top: 0px">图片</el-tag>
          <el-badge  v-for="(item,index) in qbView.imageUrlList" :key = "index"  :value="index + 1" class="item">
            <el-image   
              style="width: 100px; height: 100px;margin-left: 10px; border: 1px solid black; "
              :src="item.url"
              :fit="'fit'"></el-image>
          </el-badge>
        </div>
        <div style ="margin-top: 10px;">
          <el-checkbox-group v-model="qbView.checkedOptList">
            <el-tag type="warning">选项</el-tag>
            <el-checkbox style ="margin-left: 10px;"  v-for="(opt , index ) in qbView.optionValueArr" :label="index" :key="opt">{{opt}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div style ="margin-top: 10px;">
          <el-tag type="warning">答案</el-tag>
          <span style ="margin-left: 10px;"> {{qbView.answer }}</span>
        </div >
        <div style ="margin-top: 10px;">
          <el-tag type="warning">解析</el-tag>
          <span style ="margin-left: 10px;"> {{qbView.analysis }}</span>
        </div>
      </el-card>
    </el-dialog>
  </el-card>
  </template>                     
<script>
  // 引入组件
  import axios from  '@/api/axiosConfig'
  import {stringIsNullOrEmpty,getToken} from  '@/api/utils'
  import {PAGE_SIZE,ConstAnswerCheckTypeList,ConstAnswerCheckType,MESSAGE_DURATION,fileType,fileAreaType,roleType,regEmail,regMobilePone} from  '@/api/constant'
  export default {
      name : 'pc_ctr_qb_list',
      data() {
      return {
        actStateOptions:[
          {  
            value: '',
            label: '全部'
          },
          {  
            value: '0',
            label: '禁用'
          },
          { 
              value: '1',
              label: '激活'
          }
        ],
        answerCheckTypeList: ConstAnswerCheckTypeList,
        multipleSelection:[],
        searchFactor: {
          moduleId: '',
          question:'',
          active:'',
          uniqNo:'',
          answerCheckType:''
        },
        dialogVisual:{
          initQbVisual: false,
          editQbVisual:false,
          viewQbVisual:false
        },

        tableData: [],
        pager:{
          currentPage: '',
          totalCount:0,
          pageSize : PAGE_SIZE
        },
        qmInfoList :[],
        qbWithfileUpload :{
          refElUpload:"upload",
          analysis:'',
          answer:'',
          question :'',
          optionArr:[1],
          optionValueArr:[''],
          moduleId:'',
          answerCheckType :'',
          limit : 6,
          basicState :false,
          param: new FormData() //图片上传相关
        },
        qbWithfileUploadEdit :{
          id :'',
          updateImage:false,
          refElUpload:"uploadEdit",
          imageUrl: '',
          analysis:'',
          answer:'',
          question :'',
          optionArr:[1],
          optionValueArr:[''],
          moduleId:'',
          answerCheckType :'',
          limit : 6,
          fileListShow:[],
          countImage : '',
          row : '',
          basicState : false
        },
        qbView :{
          checkedOptList:[],
          analysis:'',
          answer:'',
          question :'',
          optionValueArr:[],
          moduleName:'',
          uniqNo:'',
          answerCheckType :'',
          countImage : '',
          basicState:false,
          imageUrlList :[]
        },
        qbInfoFile:{ 
          headers: {token:""},
          url : "/bc/exa/qb/upload",
          limit : 1,
          name :"file"
        }
      }
    },
    methods : {
      //funcUpdateImageChange(){
      //   if(this.qbWithfileUploadEdit.updateImage){
      //     this.$refs[this.qbWithfileUploadEdit.refElUpload].clearFiles();
      //     this.qbWithfileUploadEdit.fileListShow.splice(0)
      //   }else{
      //     for(let i =0 ; i< 6 ; i++){
      //       this.qbWithfileUploadEdit.fileListShow.push({name:"1231",index : i +1, url:"http://localhost:8996/static/img/xueyuan.png"})
      //     }
      //   }
      // },

      funcUpdateImageChange(){
        let row = this.qbWithfileUploadEdit.row
        let rawHasFile = false
        if(row != null && row != '' && row.countImage > 0 ){
          rawHasFile = true
        }
        if(this.qbWithfileUploadEdit.updateImage){
          if( this.$refs[this.qbWithfileUploadEdit.refElUpload] != null){
            this.$refs[this.qbWithfileUploadEdit.refElUpload].clearFiles()
          }
          if(rawHasFile){
            this.qbWithfileUploadEdit.fileListShow.splice(0)
          }
        }else{
          if(rawHasFile){
            if(row.countImage > 0){
              for(let i = 0 ; i< row.countImage ; i++){
                this.qbWithfileUploadEdit.fileListShow.push({name:"url_" + (i+1),index : i +1, url: row['fileUrl' +(i + 1)]})
              }
            }
          }
        }
      },
      handleCommand(command){
        let index  = command.index
        let row = command.data
        let event = command.event
        switch(event){
          case 'handleDelete' :
              this.handleDelete(index,row)
              break
          case 'handleEditQb' :
              this.handleEditQb(index,row)
              break
          case 'handleViewQb':
              this.handleViewQb(index,row)
              break
          case 'doActiveQb':
              this.doActiveQb(index,row)
              break
  
        }
      },
      // 创建试题获取图片的索引
      getIndex(file,refElUpload){
        if(this.$refs[refElUpload] == null ) {
          return file.index;
        }
        return  this.$refs[refElUpload].uploadFiles.findIndex(t=>t.uid == file.uid) + 1;
      },
      //创建试题删除一个图片
      handleRemove(file,refElUpload) {
        let fileList = this.$refs[refElUpload].uploadFiles
        let index = fileList.indexOf(file)
        this.$refs[refElUpload].uploadFiles.splice(index,1)
      },

      createQbWithQmChange(id){
        let item = this.qmInfoList.find(t=>t.id == id)
        if(item != undefined){
          this.qbWithfileUpload.basicState = item.basicState == 1
        }
      },

      updateQbWithQmChange(id){
        let item = this.qmInfoList.find(t=>t.id == id)
        if(item != undefined){
          this.qbWithfileUploadEdit.basicState = item.basicState == 1
        }
      },

      // 添加一个选项
      addOption(){
        if(this.qbWithfileUpload.optionArr.length >= 6){
          this.$message({
            showClose: true,
            message: "最多只能有6个选项!",
            type: 'error',
            duration: MESSAGE_DURATION
          })
          return 
        }
        this.qbWithfileUpload.optionArr.push(1)  //通过添加array的值，增加input的个数
        this.qbWithfileUpload.optionValueArr.push('')
      },
      // 删除一个选项
      delOption(index){
        if(this.qbWithfileUpload.optionArr.length <= 1){
          this.$message({
            showClose: true,
            message: "至少有一个选项！",
            type: 'error',
            duration: MESSAGE_DURATION
          })
          return
        }
        this.qbWithfileUpload.optionValueArr.splice(index,1)  
        this.qbWithfileUpload.optionArr.splice(index,1)  //然后删除array对应索引的值，实现点击删除按钮，减少input框效果
      },
      //批导
      fileUpLoadSuccess(response, file, fileList){
      this.$refs.upload.clearFiles();
      if(response.code === 0){
        this.$message({
          showClose: true,
          message: '上传成功!',
          type: 'success',
          duration: MESSAGE_DURATION
        })
      }else{
        this.$message({
          showClose: true,
          message: response.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      }
    },
    fileUpLoadError(err, file, fileList){
      this.$refs.upload.clearFiles();
      this.$message({
        showClose: true,
        message: err,
        type: 'error',
        duration: MESSAGE_DURATION
      })
    },
      formatContent(row , index){
        let res = '';
        for(let i = 0; i< 5; i++){
          let v =  row['option' + (i + 1)]
          if(v != null &&  v != '') {
            let ch = String.fromCharCode(i + 1 + 64)
            res +=  ch + "."+ v + ";"
          }
        }
        return res
      },
      handleCurrentChange(val){
        this.qbListLoad(val);
      },

      qbListLoad(pageNo){
        let url = "/bc/exa/qb/qbPage"
        let { 
          moduleId,
          question,
          uniqNo,
          active,
          answerCheckType
        } = this.searchFactor 
        let dat0 = {
          pageSize: PAGE_SIZE,
          moduleId,
          question,
          active,
          uniqNo,
          answerCheckType,
          pageNo
        }
        axios.post(url, dat0).then((response) => {
          if (response.data.code === 0) {
            let dat = response.data.data;
            if(dat.data.length !== 0){
                this.tableData = [];
                dat.data.forEach(t=>this.tableData.push(t))
                if(pageNo == 1 ) {

                  this.pager.currentPage = 1
                }
               
                this.pager.totalCount = dat.totalDataCount;
            } else {
              this.$message({
                showClose: true,
                message: '未查询到只是题库信息！',
                type: 'info',
                duration: MESSAGE_DURATION
              })
            }
          }else{
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
          }).catch((err)=>{
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          });
      },

      onSearch(){
        this.qbListLoad(1)
      },
      handleCreateQb(){
        this.dialogVisual.initQbVisual = true;
      },

      handleViewQb(index,row){
        this.dialogVisual.viewQbVisual = true
        this.qbView.analysis = row.analysis
        this.qbView.answer = row.answer
        this.qbView.question = row.question 
        this.qbView.moduleName = row.moduleName
        this.qbView.uniqNo = row.uniqNo
        this.qbView.basicState = row.basicState == 1
        this.qbView.answerCheckType = row.answerCheckType
        for(let i = 0; i< 5; i++){
            let v =  row['option' + (i + 1)]
            if(v != null &&  v != '') {
              let ch = String.fromCharCode(i + 1 + 64)
              this.qbView.optionValueArr.push(ch + "."+ v + ";")
            }
        }
        this.qbView.imageUrlList.splice(0)
        if(row.countImage > 0){
          for(let i = 0 ; i< row.countImage ; i++){
            this.qbView.imageUrlList.push({name:"url_" + (i+1),index : i +1, url: row['fileUrl' +(i + 1)]})
          }
        }
      },
      clearViewQbForm(){
        this.qbView.analysis = ''
        this.qbView.answer = ''
        this.qbView.question = ''
        this.qbView.moduleName = ''
        this.qbView.moduleName = false,
        this.qbView.uniqNo= ''
        this.qbView.optionValueArr.splice(0)
        this.qbView.imageUrlList.splice(0)
      },
      handleEditQb(index, row){
        this.dialogVisual.editQbVisual = true
        this.qbWithfileUploadEdit.countImage = row.countImage
        this.qbWithfileUploadEdit.row = row
        this.qbWithfileUploadEdit.id = row.id
        this.qbWithfileUploadEdit.analysis = row.analysis
        this.qbWithfileUploadEdit.question = row.question
        this.qbWithfileUploadEdit.moduleId = row.moduleId
        this.qbWithfileUploadEdit.basicState = row.basicState == 1
        this.qbWithfileUploadEdit.analysis = row.analysis
        this.qbWithfileUploadEdit.answer = row.answer
        this.qbWithfileUploadEdit.answerCheckType = row.answerCheckType
        this.qbWithfileUploadEdit.optionArr = []
        this.qbWithfileUploadEdit.optionValueArr = []
        for(let i =0 ; i< 6 ; i++){
          let opt = row["option" + (i + 1)] 
          if(opt!= null && opt!= ''){
            this.qbWithfileUploadEdit.optionArr.push(i)
            this.qbWithfileUploadEdit.optionValueArr.push(opt) 
          }else{
            break
          }
        }
        this.qbWithfileUploadEdit.fileListShow.splice(0)
        if(this.qbWithfileUploadEdit.countImage > 0){
          for(let i = 0 ; i< this.qbWithfileUploadEdit.countImage ; i++){
            this.qbWithfileUploadEdit.fileListShow.push({name:"url_" + (i+1),index : i +1, url: this.qbWithfileUploadEdit.row['fileUrl' +(i + 1)]})
          }
        }
      },
      handleDelete(index, row){
        this.$confirm('即将删除编号['+row.uniqNo+']的试题!', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doDeleteQb(row)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消删除！'
          });
        })
      },
      doDeleteQb(row){
        let datBat = {id: row.id}
        let url = "/bc/exa/qb/qbDelete"
        let s = JSON.stringify(datBat)  
        axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.$message({
              showClose: true,
              message: '删除成功!',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.qbListLoad(1);
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })
      },
      // 确认创建
      ensureCreate(){
        try{ 
          stringIsNullOrEmpty(this.qbWithfileUpload.moduleId ,'请选择试题模块!')
          stringIsNullOrEmpty(this.qbWithfileUpload.answerCheckType ,'请选择试题类型!')
          stringIsNullOrEmpty(this.qbWithfileUpload.question ,'请输入问题!')
          stringIsNullOrEmpty(this.qbWithfileUpload.answer ,'请输入答案!')
          stringIsNullOrEmpty(this.qbWithfileUpload.analysis ,'请输入问题解析!')
          if(this.qbWithfileUpload.optionArr.length == 0){
            throw  '至少需要一个选项'         
          }
          const optSet  =  new Set();
          for(let i = 0 ; i < this.qbWithfileUpload.optionValueArr.length;i++ ){
            let item = this.qbWithfileUpload.optionValueArr[i]
            optSet.add(String.fromCharCode(i+1 + 64))
            stringIsNullOrEmpty(item ,'选项'+ String.fromCharCode(i+1 + 64) + '为空!');
          }
          let answer = this.qbWithfileUpload.answer
          switch (this.qbWithfileUpload.answerCheckType) {
              case ConstAnswerCheckType.RADIO:
                  if(answer.length > 1){
                      throw "单选题答案只能有一个!";
                  }
                  break 
              case ConstAnswerCheckType.CHECKBOX:
                  if(answer.length <= 1) {
                      throw "多选题答案不能只有一个!";
                  }
                  break 
              case ConstAnswerCheckType.TRUE_OR_FALSE:
                  if(!"A".equals(answer) && !"B".equals(answer)){
                    throw "判断题答案只能为'A'和'B'!";
                  }
                  break 
              default:
          }

          for(let i = 0 ; i< answer.length; i++){
            if(! optSet.has(answer[i])){
                throw "答案'"+answer[i]+"'未在选项中!"
            }
          }
        }catch (e){
          this.$message({
            showClose: true,
            message: e,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
          return
        }
        let data = new FormData();
        data.append("moduleId", this.qbWithfileUpload.moduleId )
        data.append('answerCheckType', this.qbWithfileUpload.answerCheckType)
        data.append("question", this.qbWithfileUpload.question )
        data.append('answer', this.qbWithfileUpload.answer)
        data.append("analysis", this.qbWithfileUpload.analysis )
        data.append('options', this.qbWithfileUpload.optionValueArr)
        let fileRef = this.$refs[this.qbWithfileUpload.refElUpload]
        let fileList = []
         if(fileRef != null){
          fileList = fileRef.uploadFiles
          if(fileList != null && fileList.length != 0){
            fileList.forEach(t=>{
              data.append('files', t.raw)
            })
          }
        }
        let url = "/bc/exa/qb/save"
        axios.post(url, data,{
          headers: {
            'Content-Type': 'multipart/form-data',
            'token': this.qbInfoFile.headers.token
          }
        }).then((response) => {
            if (response.data.code === 0){
              this.$message({
                showClose: true,
                message: '初始化安全知识成功',
                type: 'success',
                duration: MESSAGE_DURATION
              })
              this.clearInitQbForm();
            } else {
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            }
          }).catch( (err)=> {
            this.$message({
                showClose: true,
                message: err.message,
                type: 'error',
                duration: MESSAGE_DURATION
              }) 
        })
      },

      //确认修改
      ensureEdit(){
        let fileList = []
        try{ 
          stringIsNullOrEmpty(this.qbWithfileUploadEdit.id ,'试题id为空!')
          stringIsNullOrEmpty(this.qbWithfileUploadEdit.moduleId ,'请选择试题模块!')
          stringIsNullOrEmpty(this.qbWithfileUploadEdit.answerCheckType ,'请选择试题类型!')
          stringIsNullOrEmpty(this.qbWithfileUploadEdit.question ,'请输入问题!')
          stringIsNullOrEmpty(this.qbWithfileUploadEdit.answer ,'请输入答案!')
          stringIsNullOrEmpty(this.qbWithfileUploadEdit.analysis ,'请输入问题解析!')
          if(this.qbWithfileUploadEdit.updateImage){
            let fileRef = this.$refs[this.qbWithfileUploadEdit.refElUpload]
            if(fileRef != null){
              fileList = fileRef.uploadFiles
            }
            if(fileList.length  == 0){
              throw  '请选择更新图片'         
            }
          }
          if(this.qbWithfileUploadEdit.optionArr.length == 0){
            throw  '至少需要一个选项'         
          }
          const optSet  =  new Set();
          for(let i = 0 ; i < this.qbWithfileUploadEdit.optionValueArr.length;i++ ){
            let item = this.qbWithfileUploadEdit.optionValueArr[i]
            optSet.add(String.fromCharCode(i+1 + 64))
            stringIsNullOrEmpty(item ,'选项'+ String.fromCharCode(i+1 + 64) + '为空!');
          }
          let answer = this.qbWithfileUploadEdit.answer
          switch (this.qbWithfileUploadEdit.answerCheckType) {
            case ConstAnswerCheckType.RADIO:
              if(answer.length > 1){
                  throw "单选题答案只能有一个!";
              }
              break 
            case ConstAnswerCheckType.CHECKBOX:
              if(answer.length <= 1) {
                  throw "多选题答案不能只有一个!";
              }
              break 
            case ConstAnswerCheckType.TRUE_OR_FALSE:
              if(!"A".equals(answer) && !"B".equals(answer)){
                throw "判断题答案只能为'A'和'B'!";
              }
              break 
            default:
          }

          for(let i = 0 ; i< answer.length; i++){
            if(! optSet.has(answer[i])){
                throw "答案'"+answer[i]+"'未在选项中!"
            }
          }
        }catch (e){
          this.$message({
            showClose: true,
            message: e,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
          return
        }

        let data = new FormData();
        data.append("id", this.qbWithfileUploadEdit.id )
        data.append("moduleId", this.qbWithfileUploadEdit.moduleId )
        data.append('answerCheckType', this.qbWithfileUploadEdit.answerCheckType)
        data.append("question", this.qbWithfileUploadEdit.question )
        data.append('answer', this.qbWithfileUploadEdit.answer)
        data.append("analysis", this.qbWithfileUploadEdit.analysis )
        data.append('options', this.qbWithfileUploadEdit.optionValueArr)
        
        if(this.qbWithfileUploadEdit.updateImage){
          fileList.forEach(t=>{
            data.append('files', t.raw)
          })
        }
        let url = "/bc/exa/qb/update"
        axios.post(url, data,{
          headers: {
            'Content-Type': 'multipart/form-data',
            'token': this.qbInfoFile.headers.token
          }
        }).then((response) => {
          if (response.data.code === 0){
            this.$message({
              showClose: true,
              message: '修改安全知识成功',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.clearEditQbForm();
            setTimeout(()=>{ this.qbListLoad(1)},200)
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err)=> {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })
      },

      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      indexMethod(index){
        return  index + 1
      },
      clearInitQbForm(){
        this.qbWithfileUpload.analysis = ''
        this.qbWithfileUpload.answer = ''
        this.qbWithfileUpload.question = ''
        this.qbWithfileUpload.optionArr = [1]
        this.qbWithfileUpload.optionValueArr= ['']
        this.qbWithfileUpload.moduleId = ''
        this.qbWithfileUpload.basicState = false
        this.qbWithfileUpload.answerCheckType = ''
        let fileRef = this.$refs[this.qbWithfileUpload.refElUpload]
        if(fileRef != null){
          fileRef.clearFiles()
        }
      },
      clearEditQbForm(){
        this.dialogVisual.editQbVisual = false
        this.qbWithfileUploadEdit.updateImage = false
        this.qbWithfileUploadEdit.id = ''
        this.qbWithfileUploadEdit.analysis = ''
        this.qbWithfileUploadEdit.answer = ''
        this.qbWithfileUploadEdit.basicState = false
        this.qbWithfileUploadEdit.question = ''
        this.qbWithfileUploadEdit.optionArr = [1]
        this.qbWithfileUploadEdit.optionValueArr= ['']
        this.qbWithfileUploadEdit.moduleId = ''
        this.qbWithfileUploadEdit.answerCheckType = ''
        this.qbWithfileUploadEdit.fileListShow.splice(0)
        let fileRef = this.$refs[this.qbWithfileUpload.refElUpload]
        if(fileRef != null){
          fileRef.clearFiles()
        }
      },
      qmListLoad(pageNo){
        let url = "/bc/exa/qm/qmPage"
        let dat0 = {
          pageSize: PAGE_SIZE,
          pageNo
        }
        axios.post(url, dat0).then((response) => {
          if (response.data.code === 0) {
            let dat = response.data.data;
            if(dat.data.length !== 0){
              dat.data.forEach(t=>{
                  if(t.active == 1){
                    this.qmInfoList.push(t)
                  }
                }
              )
            } else {
              this.$message({
                showClose: true,
                message: '未查询到安全知识信息！',
                type: 'info',
                duration: MESSAGE_DURATION
              })
            }
          }else{
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
          }).catch((err)=>{
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          });
      },
      handleActvieBat(){
        if( this.multipleSelection.length == 0){
          this.$message({
                showClose: true,
                message: '未选中任何试题！',
                type: 'error',
                duration: MESSAGE_DURATION
          })
          return 
        }
        let ids = [];
        this.multipleSelection.forEach(t=>{
          if(t.active == 0){
            ids.push({id:t.id})
          }
        })

        if(ids.length == 0){
          this.$message({
            showClose: true,
            message: '选中的试题都是激活状态！',
            type: 'error',
            duration: MESSAGE_DURATION
          })
          return
        }
        this.$confirm('即将要禁用选中的激活额'+ids.length+'个试题!', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doActive(0,ids)
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消！'
          });
        })
      },
      handleUnActiveBat(){
        if( this.multipleSelection.length == 0){
          this.$message({
            showClose: true,
            message: '未选中任何试题！',
            type: 'error',
            duration: MESSAGE_DURATION
          })
          return 
        }

        let ids = [];
        this.multipleSelection.forEach(t=>{
          if(t.active == 1){
            ids.push({id:t.id})
          }
        })
        
        if( ids.length == 0){
          this.$message({
            showClose: true,
            message: '选中的试题都是禁用状态！',
            type: 'error',
            duration: MESSAGE_DURATION
          })
          return
        }
        this.$confirm('即将要禁用选中的激活的'+ids.length+'个试题!', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.doActive(1,ids)
        }).catch((err) => {
          this.$message({
            type: 'info',
            message: err
          });
        })
      },
      // 单条激活
      doActiveQb(index, row){
        let ids = []
        ids.push({id:row.id})
        this.doActive (row.active, ids)
      },
      doActive (active, ids){
        let actState = active == 0  ? 1 : 0
        let url = "/bc/exa/qb/qbActive/"+ actState
        let s = JSON.stringify(ids)  
        axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.$message({
              showClose: true,
              message: '操作成功!',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            setTimeout(()=>{
              this.qbListLoad(1);
            },200);
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
        })
      }
    },
    created () {
      setTimeout(()=>{getToken(this.qbInfoFile.headers)},200)
      setTimeout(()=>{this.qmListLoad(1)},200)
      this.qbListLoad(1);
    }
  }
</script>

<style lang="less" scoped>

.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}
 </style>
    


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_qb_list.vue